import Vue from 'vue'
import Router from 'vue-router'
import Center from '@/components/center'
//首页
import Index from '@/pages/index/index.vue'

Vue.use(Router)

const router = new Router({
	routes: [{
			path: '/',
			redirect: "Index",
		},
		{
			path: '/Index',
			component: Index,
			meta: {
				title: "首页"
			}
		},
	]
})

router.beforeEach((to, from,next) => {
	let page_name=from.meta.title;
	let s=jm.getStorageItem("p_stime")?jm.getStorageItem("p_stime"):"";
	let e=jm.getDateString(new Date());
	if(page_name&&page_name=="错误信息"){
		let type=from.query.type
		page_name+="_"+type;
	}
	let log_content="页面进入，开始时间："+s+",结束时间："+e;
	if (is_get_gps) jm.dataPUv();
	if(page_name) jm.dataClick({
		page_name:page_name,
		log_content:log_content
	});
	next();
})
router.afterEach((to, from) => {
	jm.setStorageItem("p_stime",jm.getDateString(new Date()));
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js